import { forwardRef } from 'react';
import { cn } from '../../util';

const TableFooter = forwardRef<HTMLTableSectionElement, React.HTMLAttributes<HTMLTableSectionElement>>(
  ({ className, ...props }, ref) => (
    <tfoot ref={ref} className={cn('border-t font-bold [&>tr]:last:border-b-0', className)} {...props} />
  )
);

TableFooter.displayName = 'TableFooter';

export default TableFooter;
